/** Menu, compte personnel (e-mail et mot de passe, clés d'accès, double authentification, quitter une entreprise, supprimer son compte), position. */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const MenuPage = lazy(() => import('./MenuPage.js').then((m) => ({ default: m.MenuPage })));
const AccountPage = lazy(() => import('./AccountPage.js').then((m) => ({ default: m.AccountPage })));
const AccountAccessPage = lazy(() => import('./AccountAccessPage.js').then((m) => ({ default: m.AccountAccessPage })));
const EmailChangePage = lazy(() => import('./EmailChangePage.js').then((m) => ({ default: m.EmailChangePage })));
const PasswordChangePage = lazy(() => import('./PasswordChangePage.js').then((m) => ({ default: m.PasswordChangePage })));
const PasskeysPage = lazy(() => import('./PasskeysPage.js').then((m) => ({ default: m.PasskeysPage })));
const MfaPage = lazy(() => import('./MfaPages.js').then((m) => ({ default: m.MfaPage })));
const MfaEnrollPage = lazy(() => import('./MfaPages.js').then((m) => ({ default: m.MfaEnrollPage })));
const LeaveCompanyPage = lazy(() => import('./LeaveCompanyPage.js').then((m) => ({ default: m.LeaveCompanyPage })));
const DeleteAccountPage = lazy(() => import('./DeleteAccountPage.js').then((m) => ({ default: m.DeleteAccountPage })));
const LocationPage = lazy(() => import('./LocationAccess.js').then((m) => ({ default: m.LocationPage })));

export const profileRoutes: AppRoute[] = [
  { path: '/profil', element: <MenuPage /> },
  { path: '/profil/compte', element: <AccountPage /> },
  { path: '/profil/compte/acces', element: <AccountAccessPage /> },
  { path: '/profil/compte/acces/email', element: <EmailChangePage /> },
  { path: '/profil/compte/acces/mot-de-passe', element: <PasswordChangePage /> },
  { path: '/profil/compte/cles-acces', element: <PasskeysPage /> },
  { path: '/profil/compte/double-authentification', element: <MfaPage /> },
  { path: '/profil/compte/double-authentification/activer', element: <MfaEnrollPage mode="activer" /> },
  { path: '/profil/compte/double-authentification/changer', element: <MfaEnrollPage mode="changer" /> },
  { path: '/profil/compte/quitter-une-entreprise', element: <LeaveCompanyPage /> },
  { path: '/profil/compte/supprimer', element: <DeleteAccountPage /> },
  { path: '/profil/position', element: <LocationPage /> },
];
